import { Outlet, useOutletContext } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { AutomationDetails } from 'modules/automations/components/AutomationDetails'
import type { ShowRouteContextParams } from 'modules/automations/lib/ShowRouteContextParams'
import { InsertAutomationProvider } from 'modules/automations/lib/automationContext'
import contractVersions from 'modules/contracts/store/collections/contractVersions'

const DetailsPage = () => {
  const { automation, trigger, back } = useOutletContext<ShowRouteContextParams>()
  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )
  if (trigger === undefined) return <></>

  if (!automation) {
    return <NotFound />
  }

  if (loading) {
    return <Loading />
  }

  return (
    <InsertAutomationProvider>
      <AutomationDetails
        automation={automation}
        trigger={trigger}
        back={back}
        contractVersions={contractVersions}
      >
        {trigger && <Outlet context={trigger} />}
      </AutomationDetails>
    </InsertAutomationProvider>
  )
}

export default DetailsPage
